// Sensitive-document detector. Never returns the matched substring — only the
// type and a coarse location, so nothing sensitive ends up in logs or storage.

import type { SensitiveHit } from "./types";

const SSN = /\b\d{3}-\d{2}-\d{4}\b/;
const EIN = /\b\d{2}-\d{7}\b/;
const W9_FORM = /\b(form\s*w[- ]?9|substitute\s*w[- ]?9|request\s+for\s+taxpayer\s+identification)\b/i;
const TAXPAYER = /\btaxpayer\s+identification\s+number|\btin\b/i;

export function detectSensitiveInText(text: string, location: string): SensitiveHit[] {
  const hits: SensitiveHit[] = [];
  if (SSN.test(text)) hits.push({ kind: "ssn", location });
  if (EIN.test(text)) hits.push({ kind: "ein", location });
  if (W9_FORM.test(text)) hits.push({ kind: "w9_form", location });
  else if (TAXPAYER.test(text)) hits.push({ kind: "taxpayer_id", location });
  return hits;
}

export function redactSensitive(text: string): string {
  return text
    .replace(new RegExp(SSN, "g"), "[REDACTED-SSN]")
    .replace(new RegExp(EIN, "g"), "[REDACTED-EIN]");
}

export function sensitiveKindLabel(k: SensitiveHit["kind"]): string {
  switch (k) {
    case "ssn": return "SSN pattern";
    case "ein": return "EIN pattern";
    case "w9_form": return "W-9 form";
    case "taxpayer_id": return "Taxpayer ID reference";
  }
}
